import * as React from 'react';
import { cn } from '@/lib/utils';
import { cva } from 'class-variance-authority';

const metricSectionVariants = cva('relative p-5 pt-10 border-[3px] border-solid rounded-md [&_p]:m-0', {
  variants: {
    variant: {
      primary: 'border-primary-lightest [&_.c-metric-hat]:text-primary [&_.c-metric-hat]:bg-primary-lightest',
      conquest: 'border-[#ECE9F8] [&_.c-metric-hat]:text-[#7B63BF] [&_.c-metric-hat]:bg-[#ECE9F8]',
      mission: 'border-[#FFECD8] [&_.c-metric-hat]:text-[#F99153] [&_.c-metric-hat]:bg-[#FFECD8]',
      merit: 'border-[#FFE7E5] [&_.c-metric-hat]:text-[#FF4C6F] [&_.c-metric-hat]:bg-[#FFE7E5]'
    }
  },
  defaultVariants: {
    variant: 'primary'
  }
});

const MetricSection = React.forwardRef(({ variant, className, ...props }, ref) => (
  <section
    ref={ref}
    className={cn('c-metric-section', metricSectionVariants({ variant }), className)}
    {...props}
  />
));
MetricSection.displayName = 'MetricSection';

const MetricHat = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn(
      'c-metric-hat',
      'absolute left-1/2 top-0 mb-0 inline-flex w-max -translate-x-1/2 items-center justify-center rounded-b-md border-2 border-t-0 border-solid border-white bg-neutral-100 p-[2px_8px] text-sm font-bold uppercase text-neutral shadow-dropshadow',
      className
    )}
    {...props}
  />
));
MetricHat.displayName = 'MetricHat';

export { MetricSection, MetricHat };
